/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { ReadNotificationsApiResponse } from '../types/notificationsApi.types';

/**
 * Transforms the read notifications endpoint response.
 *
 * @param response The response from the endpoint.
 */
export function transformReadNotifications(
  response: any,
): ReadNotificationsApiResponse {
  response.data.notifications.forEach((notification) => {
    try {
      notification.payload_data = JSON.parse(notification.payload);
      notification.is_local = false;
    } catch (e) {
      // Not a valid json payload
    }
  });

  return response;
}
